import { HStack, Img, Text, VStack } from "@chakra-ui/react"
import { FiMail, FiMapPin, FiPhone } from 'react-icons/fi'

const Footer = () => {
    return (
        <HStack bg={'#041e42'} justify={'space-around'} pt={'2rem'} pb={'3rem'}>
            <VStack>
                <Img w={'240px'} src={'/assets/images/as-logo-colored.png'} />
                <Text color={'white'} fontSize={'xs'}>&copy; 2023 | Analyticsmart Consulting Inc.</Text>
            </VStack>
            <VStack align={'start'}>
                <Text color={'white'} fontSize={'2xl'}>Toronto Office</Text>
                <Text color={'white'}>T171 E Liberty St #301</Text>
                <Text color={'white'}>Toronto, ON M6K 3P6</Text>
            </VStack>
            <VStack align={'start'}>
                <Text color={'white'} fontSize={'2xl'}>Montreal Office</Text>
                <Text color={'white'}>360 St Jacques St.</Text>
                <Text color={'white'}>Montreal, Quebec H2Y 1P5</Text>
            </VStack>
            <VStack  align={'start'}>.
                <HStack cursor={'pointer'} align={'center'}>
                    <FiMail color={'white'} />
                    <Text color={'white'}>info@analyticsmart.com</Text>
                </HStack>
                <HStack cursor={'pointer'} align={'center'}>
                    <FiPhone color={'white'} />
                    <Text color={'white'}>(647) 748-7875</Text>
                </HStack>
                
            </VStack>
        </HStack>
    )
}

export default Footer